import { render, staticRenderFns } from "./BtnAddUser.vue?vue&type=template&id=cca09154&scoped=true"
import script from "./BtnAddUser.vue?vue&type=script&lang=js"
export * from "./BtnAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca09154",
  null
  
)

export default component.exports